import React, { useState } from "react";
import "./Apply.css";
import Navbar2 from "../Navbar2/Navbar2"
import Footer from "../../Components/Footer/Footer"
import SuccessDialog from "../../Components/SuccessDialog/SuccessDialog";

import { submitApplication } from "../../services/applicationService";

import {
    genderOptions,
    educationOptions,
    domainOptions,
    durationOptions,
    contactMethodOptions,
    hearAboutOptions,
    stateOptions
} from "../../Data/selectOptions";
import CustomSelect from "../CustomSelect/CustomSelect";

import { validateApplication } from "../../utils/validation";

import {
    FaUser,
    FaMapMarkerAlt,
    FaGraduationCap,
    FaBriefcase,
    FaUsers,
    FaCheckCircle,
    FaCloudUploadAlt,
    FaLinkedinIn,
    FaInstagram,
    FaArrowRight
} from "react-icons/fa";

const Apply = () => {
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);

    const [applicationInfo, setApplicationInfo] = useState({
        applicationId: "",
        fullName: "",
        email: "",
        domain: ""
    });

    const [errors, setErrors] = useState({});

    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({

        // Personal

        fullName: "",
        mobile: "",
        email: "",
        dob: "",
        gender: "",

        // Address

        state: "",
        city: "",
        address: "",
        pincode: "",

        // Education

        college: "",
        course: "",
        educationLevel: "",
        tpoName: "",
        tpoEmail: "",
        tpoContact: "",

        // Internship

        domain: "",
        contactMethod: "",
        duration: "",
        hearAbout: "",
        previousExperience: "",
        whyJoin: "",

        // Social

        linkedinFollowed: false,
        instagramFollowed: false,

        // Declaration

        declaration: false

    });

    const [resume, setResume] = useState(null);

   const handleChange = (e) => {

    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value
    }));

    setErrors((prev) => ({
        ...prev,
        [name]: ""
    }));

};

  const handleResume = (e) => {

    const file = e.target.files[0];

    if (!file) return;

    setResume(file);

    setErrors((prev) => ({
        ...prev,
        resume: ""
    }));

};

const handleSubmit = async (e) => {

    e.preventDefault();

    const validation = validateApplication(formData, resume);

    if (!validation.isValid) {

        setErrors(validation.errors);

        setTimeout(() => {

            const firstError = Object.keys(validation.errors)[0];

            let element;

            if (firstError === "resume") {

                element = document.getElementById("resume-section");

            } else {

                element =
                    document.getElementById(firstError) ||
                    document.querySelector(`[name="${firstError}"]`);

            }

            if (element) {

                element.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });

                if (typeof element.focus === "function") {
                    element.focus();
                }

            }

        }, 100);

        return;

    }

setErrors({});

            const data = new FormData();

            // Append all text fields
            Object.keys(formData).forEach((key) => {
                data.append(key, formData[key]);
            });

            // Append resume
            data.append("resume", resume);

            try {

                setLoading(true);

                const response = await submitApplication(data);

                setApplicationInfo({
                    applicationId: response.data.applicationId,
                    fullName: formData.fullName,
                    email: formData.email,
                    domain: formData.domain
                });

                setShowSuccessDialog(true);

                // Reset Form
                setFormData({

                    fullName: "",
                    mobile: "",
                    email: "",
                    dob: "",
                    gender: "",

                    state: "",
                    city: "",
                    address: "",
                    pincode: "",

                    college: "",
                    course: "",
                    educationLevel: "",
                    tpoName: "",
                    tpoEmail: "",
                    tpoContact: "",

                    domain: "",
                    contactMethod: "",
                    duration: "",
                    hearAbout: "",
                    previousExperience: "",
                    whyJoin: "",

                    linkedinFollowed: false,
                    instagramFollowed: false,

                    declaration: false

                });

                setResume(null);

            } catch (error) {

                console.error(error);

                alert(
                    error.response?.data?.message ||
                    "Application submission failed."
                );

            } finally {

                setLoading(false);

            }

};
const handleSuccessDialogClose = () => {

    setShowSuccessDialog(false);

};

    return (

        <div className="apply-page">
            <Navbar2/>

            {/* ================= HERO ================= */}

            <section className="apply-hero">
                  
                <div className="apply-hero-content">
                <div className="glass-overlay"></div>
                    <span className="apply-hero-tag">
                        Internship Program 2026
                    </span>

                    <h1>
                        Apply For Internship at 
                        <span className="horyzen-why"> HORYZEN </span>
                    </h1>

                    <p>
                        Build your career through real-world industry projects,
                        mentorship from professionals and hands-on learning.
                        Complete the application below to begin your journey.
                    </p>

                    <div className="apply-hero-stats">

                        <div className="apply-hero-stat">
                            <span className="stat-number">
                                500+
                            </span>
                            <span className="stat-title">
                                Applications
                            </span>
                        </div>

                        <div className="apply-hero-stat">
                            <span className="stat-number">
                                20+
                            </span>
                            <span className="stat-title">
                                Internship Domains
                            </span>
                        </div>

                        <div className="apply-hero-stat">
                            <span className="stat-number">
                                100%
                            </span>
                            <span className="stat-title">
                                Remote Program
                            </span>
                        </div>

                        <div className="apply-hero-stat">
                            <span className="stat-number">
                                Certified
                            </span>
                            <span className="stat-title">
                                Internship
                            </span>
                        </div>

                    </div>

                </div>

            </section>

            {/* ================= FORM ================= */}

            <form
                className="application-form"
                onSubmit={handleSubmit} noValidate>

                {/* ================= PERSONAL DETAILS ================= */}

                <section className="form-card">

                    <div className="card-header">

                        <div className="card-icon">
                            <FaUser />
                        </div>

                        <div className="card-content">

                            <h2>
                                Personal Details
                            </h2>

                            <p>
                                Tell us about yourself.
                            </p>

                        </div>

                    </div>

                    <div className="form-grid">

                        {/* Full Name */}

                        <div
                                id="fullName"
                                className={`input-group ${formData.fullName ? "filled" : ""} ${
                                    errors.fullName ? "input-group-error" : ""
                                }`}
                            >

                                <input
                                    type="text"
                                    name="fullName"
                                    value={formData.fullName}
                                    onChange={handleChange}
                                    placeholder=" "
                                    autoComplete="off"
                                    required
                                />

                                <label>
                                    Full Name *
                                </label>

                                <div className="input-line"></div>

                                {errors.fullName && (
                                    <p className="error-message">
                                        {errors.fullName}
                                    </p>
                                )}

                            </div>

                        {/* Mobile */}

                       <div
                        id="mobile"
                        className={`input-group ${formData.mobile ? "filled" : ""} ${
                            errors.mobile ? "input-group-error" : ""
                        }`}
                    >

                        <input
                            type="tel"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                            placeholder=" "
                            autoComplete="off"
                            required
                        />

                        <label>
                            Mobile Number *
                        </label>

                        <div className="input-line"></div>

                        {errors.mobile && (
                            <p className="error-message">
                                {errors.mobile}
                            </p>
                        )}

                       </div>

                        {/* Email */}

                        <div
                            id="email"
                            className={`input-group ${formData.email ? "filled" : ""} ${
                                errors.email ? "input-group-error" : ""
                            }`}
                        >

                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder=" "
                                autoComplete="off"
                                required
                            />

                            <label>
                                Email Address *
                            </label>

                            <div className="input-line"></div>

                            {errors.email && (
                                <p className="error-message">
                                    {errors.email}
                                </p>
                            )}

                        </div>

                        {/* Date of Birth */}

                        <div
                            id="dob"
                            className={`input-group ${formData.dob ? "filled" : ""} ${
                                errors.dob ? "input-group-error" : ""
                            }`}
                        >

                            <input
                                type="date"
                                name="dob"
                                value={formData.dob}
                                onChange={handleChange}
                                required
                            />

                            <label>
                                Date of Birth *
                            </label>

                            <div className="input-line"></div>

                            {errors.dob && (
                                <p className="error-message">
                                    {errors.dob}
                                </p>
                            )}

                        </div>

                        {/* Gender */}

                      <CustomSelect
                            name="gender"
                            label="Gender"
                            value={formData.gender}
                            options={genderOptions}
                            onChange={handleChange}
                            error={errors.gender}
                        />

                        

                    </div>

                </section>
                                {/* ================= ADDRESS DETAILS ================= */}

                <section className="form-card">

                    <div className="card-header">

                        <div className="card-icon">
                            <FaMapMarkerAlt />
                        </div>

                        <div className="card-content">

                            <h2>
                                Address Details
                            </h2>

                            <p>
                                Let us know where you currently reside.
                            </p>

                        </div>

                    </div>

                    <div className="form-grid">

                        {/* State */}

                       <CustomSelect
                            name="state"
                            label="State"
                            value={formData.state}
                            options={stateOptions}
                            onChange={handleChange}
                            error={errors.state}
                            required
                            isSearchable
                        />

                        {/* City */}

                        <div
                                id="city"
                                className={`input-group ${formData.city ? "filled" : ""} ${
                                    errors.city ? "input-group-error" : ""
                                }`}
                            >

                                <input
                                    type="text"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    placeholder=" "
                                    autoComplete="off"
                                    required
                                />

                                <label>
                                    City *
                                </label>

                                <div className="input-line"></div>

                                {errors.city && (
                                    <p className="error-message">
                                        {errors.city}
                                    </p>
                                )}

                        </div>

                        {/* Address */}

                         <div
                            id="address"
                            className={`input-group full-width ${formData.address ? "filled" : ""} ${
                                errors.address ? "input-group-error" : ""
                            }`}
                        >

                            <textarea
                                name="address"
                                rows="2"
                                value={formData.address}
                                onChange={handleChange}
                                placeholder=" "
                                required
                            />

                            <label>
                                Full Address *
                            </label>

                            <div className="input-line"></div>

                            {errors.address && (
                                <p className="error-message">
                                    {errors.address}
                                </p>
                            )}

                        </div>

                        {/* Pincode */}

                        <div
                            id="pincode"
                            className={`input-group ${formData.pincode ? "filled" : ""} ${
                                errors.pincode ? "input-group-error" : ""
                            }`}
                        >

                            <input
                                type="text"
                                name="pincode"
                                value={formData.pincode}
                                onChange={handleChange}
                                placeholder=" "
                                autoComplete="off"
                                maxLength={6}
                                required
                            />

                            <label>
                                Pin Code *
                            </label>

                            <div className="input-line"></div>

                            {errors.pincode && (
                                <p className="error-message">
                                    {errors.pincode}
                                </p>
                            )}

                        </div>

                    </div>

                </section>

                {/* ================= EDUCATIONAL DETAILS ================= */}

                <section className="form-card">

                    <div className="card-header">

                        <div className="card-icon">
                            <FaGraduationCap />
                        </div>

                        <div className="card-content">

                            <h2>
                                Educational Details
                            </h2>

                            <p>
                                Tell us about your academic background.
                            </p>

                        </div>

                    </div>

                    <div className="form-grid">

                        {/* College */}

                        <div
                            id="college"
                            className={`input-group full-width ${formData.college ? "filled" : ""} ${
                                errors.college ? "input-group-error" : ""
                            }`}
                        >

                            <input
                                type="text"
                                name="college"
                                value={formData.college}
                                onChange={handleChange}
                                placeholder=" "
                                autoComplete="off"
                                required
                            />

                            <label>
                                College / University Name *
                            </label>

                            <div className="input-line"></div>

                            {errors.college && (
                                <p className="error-message">
                                    {errors.college}
                                </p>
                            )}

                        </div>

                        {/* Course */}

                       <div
                            id="course"
                            className={`input-group ${formData.course ? "filled" : ""} ${errors.course ? "input-group-error" : ""}`}
                        >

                            <input
                                type="text"
                                id="course-input"
                                name="course"
                                value={formData.course}
                                onChange={handleChange}
                                placeholder=" "
                            />

                            <label htmlFor="course-input">
                                Course Name *
                            </label>

                            <div className="input-line"></div>

                            {errors.course && (
                                <p className="error-message">
                                    {errors.course}
                                </p>
                            )}

                        </div>

                        {/* Education Level */}

                        <CustomSelect
                            name="educationLevel"
                            label="Education Level"
                            value={formData.educationLevel}
                            options={educationOptions}
                            onChange={handleChange}
                            error={errors.educationLevel}
                            required
                        />

                        {/* TPO Name */}

                        <div
                            id="tpoName"
                            className={`input-group ${formData.tpoName ? "filled" : ""} ${
                                errors.tpoName ? "input-group-error" : ""
                            }`}
                        >

                            <input
                                type="text"
                                name="tpoName"
                                value={formData.tpoName}
                                onChange={handleChange}
                                placeholder=" "
                                autoComplete="off"
                            />

                            <label>
                                TPO Name
                            </label>

                            <div className="input-line"></div>

                            {errors.tpoName && (
                                <p className="error-message">
                                    {errors.tpoName}
                                </p>
                            )}

                        </div>

                        {/* TPO Email */}

                       <div
                            id="tpoEmail"
                            className={`input-group ${formData.tpoEmail ? "filled" : ""} ${
                                errors.tpoEmail ? "input-group-error" : ""
                            }`}
                        >

                            <input
                                type="email"
                                name="tpoEmail"
                                value={formData.tpoEmail}
                                onChange={handleChange}
                                placeholder=" "
                                autoComplete="off"
                            />

                            <label>
                                TPO Email
                            </label>

                            <div className="input-line"></div>

                            {errors.tpoEmail && (
                                <p className="error-message">
                                    {errors.tpoEmail}
                                </p>
                            )}

                        </div>

                        {/* TPO Contact */}

                      <div
                            id="tpoContact"
                            className={`input-group ${formData.tpoContact ? "filled" : ""} ${
                                errors.tpoContact ? "input-group-error" : ""
                            }`}
                        >

                            <input
                                type="tel"
                                name="tpoContact"
                                value={formData.tpoContact}
                                onChange={handleChange}
                                placeholder=" "
                                autoComplete="off"
                            />

                            <label>
                                TPO Contact Number
                            </label>

                            <div className="input-line"></div>

                            {errors.tpoContact && (
                                <p className="error-message">
                                    {errors.tpoContact}
                                </p>
                            )}

                        </div>

                    </div>

                </section>
                                {/* ================= INTERNSHIP DETAILS ================= */}

                <section className="form-card">

                    <div className="card-header">

                        <div className="card-icon">
                            <FaBriefcase />
                        </div>

                        <div className="card-content">

                            <h2>
                                Internship Details
                            </h2>

                            <p>
                              Select your Internship
                            </p>

                        </div>

                    </div>

                    <div className="form-grid">

                        {/* Preferred Domain */}

                        <CustomSelect
                            name="domain"
                            label="Preferred Domain"
                            value={formData.domain}
                            options={domainOptions}
                            onChange={handleChange}
                            error={errors.domain}
                            required
                            isSearchable
                        />

                        {/* Contact Method */}

                        <CustomSelect
                            name="contactMethod"
                            label="Preferred Contact Method"
                            value={formData.contactMethod}
                            options={contactMethodOptions}
                            onChange={handleChange}
                            error={errors.contactMethod}
                            required
                        />

                        {/* Duration */}

                        <CustomSelect
                            name="duration"
                            label="Internship Duration"
                            value={formData.duration}
                            options={durationOptions}
                            onChange={handleChange}
                            error={errors.duration}
                            required
                        />

                        {/* Source */}

                      <CustomSelect
                                name="hearAbout"
                                label="Where did you hear about us?"
                                value={formData.hearAbout}
                                options={hearAboutOptions}
                                onChange={handleChange}
                                error={errors.hearAbout}
                                required
                            />

                        {/* Resume Upload */}

                        <div  id="resume-section" className="upload-container full-width">

                            <label className="upload-title">
                                Upload Resume *
                            </label>

                            <div className="upload-box">

                                <input
                                    id="resume"
                                    type="file"
                                    accept=".pdf,.doc,.docx"
                                    hidden
                                    onChange={handleResume}
                                />

                                <label
                                    htmlFor="resume"
                                    className="upload-content"
                                >

                                    <FaCloudUploadAlt className="upload-icon" />

                                    <h3>

                                        {resume ? resume.name : "Upload Your Resume"}

                                    </h3>

                                    <p>

                                        Drag & Drop your resume here

                                        <br />

                                        or click to browse

                                    </p>

                                    <span>

                                        PDF • DOC • DOCX

                                        <br />

                                        Maximum File Size : 10 MB

                                    </span>

                                </label>

                            </div>
                                                        {errors.resume && (
                                <p className="error-message">
                                    {errors.resume}
                                </p>
                            )}

                        </div>

                        {/* Previous Experience */}

                        <div className="radio-wrapper full-width">

                            <h4>

                                Previous Internship Experience *

                            </h4>

                            <div className="radio-grid">

                                <label className="radio-card">

                                    <input
                                        type="radio"
                                        name="previousExperience"
                                        value="Yes"
                                        checked={formData.previousExperience === "Yes"}
                                        onChange={handleChange}
                                    />

                                    <span className="radio-circle"></span>

                                    <span className="radio-text">

                                        Yes

                                    </span>

                                </label>

                                <label className="radio-card">

                                    <input
                                        type="radio"
                                        name="previousExperience"
                                        value="No"
                                        checked={formData.previousExperience === "No"}
                                        onChange={handleChange}
                                    />

                                    <span className="radio-circle"></span>

                                    <span className="radio-text">

                                        No

                                    </span>

                                </label>

                            </div>
                                {errors.previousExperience && (
                                <p className="error-message">
                                    {errors.previousExperience}
                                </p>
                            )}

                        </div>

                        {/* Why Join */}

                         <div
                            id="whyJoin"
                            className={`input-group full-width ${formData.whyJoin ? "filled" : ""} ${
                                errors.whyJoin ? "input-group-error" : ""
                            }`}
                        >

                            <textarea
                                rows="5"
                                name="whyJoin"
                                value={formData.whyJoin}
                                onChange={handleChange}
                                placeholder=" "
                                required
                            />

                            <label>
                                Why do you want to join <span className="horyzen-text">HORYZEN</span>?
                            </label>

                            <div className="input-line"></div>

                            {errors.whyJoin && (
                                <p className="error-message">
                                    {errors.whyJoin}
                                </p>
                            )}

                        </div>

                    </div>

                </section>
                                {/* ================= SOCIAL COMMUNITY ================= */}

                <section className="form-card">

                    <div className="card-header">

                        <div className="card-icon">
                            <FaUsers />
                        </div>

                        <div className="card-content">

                            <h2>
                                Join Our Community
                            </h2>

                            <p>
                                Stay connected with <span className="horyzen-text">HORYZEN</span>
                            </p>

                        </div>

                    </div>

                    <div className="social-wrapper">

                        <div className="social-card">

                            <div className="social-top">

                                <div className="social-logo linkedin">
                                    <FaLinkedinIn />
                                </div>

                                <div>

                                    <h3>
                                        LinkedIn
                                    </h3>

                                    <p>
                                        Follow us to receive placement drives, internship updates and career opportunities.
                                    </p>

                                </div>

                            </div>

                            <button
                                type="button"
                                className="social-btn"
                                onClick={() => window.open("https://www.linkedin.com/company/horyzen-technologies/", "_blank")}
                            >
                                Follow LinkedIn
                            </button>

                            <label className="social-check">

                                <input
                                    type="checkbox"
                                    name="linkedinFollowed"
                                    checked={formData.linkedinFollowed}
                                    onChange={handleChange}
                                />

                                <span className="custom-check"></span>

                                <h2>I have followed Horyzen Tchnologies</h2>

                            </label>

                        </div>

                        <div className="social-card">

                            <div className="social-top">

                                <div className="social-logo instagram">
                                    <FaInstagram />
                                </div>

                                <div>

                                    <h3>
                                        Instagram
                                    </h3>

                                    <p>
                                        Get interview schedules, workshops, certificates and internship announcements.
                                    </p>

                                </div>

                            </div>

                            <button
                                type="button"
                                className="social-btn"
                                onClick={() => window.open("https://www.instagram.com/horyzen_technologies?igsh=MWtkbTR1YW8ydjN1", "_blank")}
                            >
                                Follow Instagram
                            </button>

                            <label className="social-check">

                                <input
                                    type="checkbox"
                                    name="instagramFollowed"
                                    checked={formData.instagramFollowed}
                                    onChange={handleChange}
                                />

                                <span className="custom-check"></span>

                                <h2>I have followed Horyzen Technologies</h2>

                            </label>

                        </div>

                    </div>

                    <div className="info-note">

                        <FaCheckCircle />

                        <p>

                            Following our social media pages helps you receive internship announcements,
                            interview schedules, workshops, certificates and placement updates much faster.

                        </p>

                    </div>

                </section>

                {/* ================= DECLARATION ================= */}

                <section className="form-card">

                    <div className="card-header">

                        <div className="card-icon">
                            <FaCheckCircle />
                        </div>

                        <div className="card-content">

                            <h2>
                                Declaration
                            </h2>

                            <p>
                                Please verify your information before submitting.
                            </p>

                        </div>

                    </div>

                    <label className="declaration-box">

                        <input
                            type="checkbox"
                            name="declaration"
                            checked={formData.declaration}
                            onChange={handleChange}
                            required
                        />

                        <span className="custom-check"></span>

                        <p>

                            I hereby declare that all information provided by me is true and correct.
                            I understand that submitting false information may result in rejection of my internship application.

                        </p>

                    </label>
                    {errors.declaration && (
                        <p className="error-message">
                            {errors.declaration}
                        </p>
                    )}

                </section>

                {/* ================= SUBMIT ================= */}

                <section className="submit-section">

                 <button
                        type="submit"
                        className="submit-btn-apply"
                        disabled={loading}
                    >
                        {loading ? "Submitting..." : "Submit Application"}

                        {!loading && <FaArrowRight />}
                    </button>

                    <p className="submit-note">

                        By submitting this application, you agree to <span className="horyzen-text">HORYZEN</span> Internship Terms & Conditions
                        and Privacy Policy.

                    </p>

                </section>

            </form>
            <SuccessDialog
                open={showSuccessDialog}
                application={applicationInfo}
                onClose={handleSuccessDialogClose}
            />

            <Footer />

        </div>

    );

};

export default Apply;